
import { defineComponent } from 'vue-demi';
import { routerNamesNew } from '@/const/route-key-map';
const name = 'HeaderStep';

export default defineComponent({
  name,
  props: {
    curStep: {
      type: Number,
      default: 1,
    },
    previousStep: {
      type: String,
    },
  },

  setup(props) {
    const steps = routerNamesNew.map((item, idx) => ({
      name: item,
      index: idx + 1,
    }));
    const handleBack = (router, route) => {
      if (props.curStep === 1) {
        router.push({ name: 'perf-dashboard-detail', query: { ...route.query } });
        return;
      }
      router.push({ name: props.previousStep, query: { ...route.query } });
    };
    const view = {
      1: 'objective',
      2: 'creative',
      3: 'audience',
    };
    const handleSwitch = (router, route, step) => {
      if (step < props.curStep) {
        router.push({ name: view[step], query: { ...route.query } });
      }
      return;
    };
    return {
      name,
      steps,
      handleBack,
      handleSwitch,
    };
  },
});
